// IMPORTANT — this file has a prebuilt sibling, gb-timeslots.bundle.js, that
// most live stores actually load (grep `theme/src/*/snippets/grocerbox.liquid`
// for "gb-timeslots.bundle" vs `type="text/babel"` to see which stores use
// which — the text/babel stores transpile this raw file in-browser and pick
// up changes automatically; the bundle stores do NOT, until the bundle is
// regenerated). Any change here must be followed by rebuilding the bundle:
//   cd server && npm install (first time only) && npm run build-timeslots
// That runs `babel public/shopify/gb-timeslots.js --out-file
// public/shopify/gb-timeslots.bundle.js --presets=@babel/preset-react` (see
// server/package.json). Verify afterwards with:
//   node --check public/shopify/gb-timeslots.bundle.js
//   npm run check-timeslots-bundle   (warns if the two have drifted)
(function gbTimeslotsDiagBootstrap() {
  if (typeof console === "undefined" || typeof console.info !== "function") {
    return;
  }
  var st = window.styled;
  var deps = {
    hasReact: typeof window.React !== "undefined",
    hasReactDOM: typeof window.ReactDOM !== "undefined",
    hasStyled: typeof st !== "undefined",
    styledTypeof: typeof st,
    styledDivCallable: typeof st === "function" && typeof st.div === "function",
    hasGrocerBoxStyledSnapshot: typeof window.__GROCERBOX_STYLED_SNAPSHOT__ !== "undefined",
    hasStyledComponentsGlobal: typeof window.styledComponents !== "undefined",
    hasCartJS: typeof window.CartJS !== "undefined",
    hasJQuery: typeof window.jQuery !== "undefined" && typeof window.$ !== "undefined"
  };
  console.info("[GrocerBox][TimeSlot]", "gb-timeslots bootstrap start", {
    dependencies: deps
  });
})();
(function resolveGrocerBoxStyledComponents() {
  function isStyledTagFactory(obj) {
    return obj && typeof obj === "function" && typeof obj.div === "function" && typeof obj.button === "function";
  }
  var w = window;
  // Prefer snapshot + styledComponents before window.styled: many themes overwrite
  // window.styled after styled-components loads, which breaks gbSc.div even though
  // the real API was correct at load time (see grocerbox.liquid snapshot script).
  var resolved = isStyledTagFactory(w.__GROCERBOX_STYLED_SNAPSHOT__) && w.__GROCERBOX_STYLED_SNAPSHOT__ || w.styledComponents && isStyledTagFactory(w.styledComponents.default) && w.styledComponents.default || isStyledTagFactory(w.styledComponents) && w.styledComponents || w.styled && isStyledTagFactory(w.styled.default) && w.styled.default || isStyledTagFactory(w.styled) && w.styled || null;
  w.__GROCERBOX_STYLED_COMPONENTS__ = resolved;
  if (!resolved && typeof console !== "undefined" && typeof console.error === "function") {
    var st = w.styled;
    console.error("[GrocerBox][TimeSlot]", "Could not resolve styled-components tag API (callable .div). window.styled may be overwritten by the theme.", {
      styledType: typeof st,
      styledKeys: st && typeof st === "object" ? Object.keys(st).slice(0, 40) : null
    });
  }
})();
(function gbTimeslotsBundleBody() {
  var gbSc = window.__GROCERBOX_STYLED_COMPONENTS__;
  if (!gbSc) {
    window.GrocerBoxTimeSlotInit = function () {
      if (typeof console !== "undefined" && typeof console.error === "function") {
        console.error("[GrocerBox][TimeSlot]", "styled-components tag API missing (gbSc). Load styled-components + __GROCERBOX_STYLED_SNAPSHOT__ BEFORE gb-timeslots.bundle.js; themes that overwrite window.styled break this unless the snapshot runs.");
      }
    };
    return;
  }
  const Container = gbSc.div`
  max-width: 48rem;
  margin: 0 auto 1.5rem;
`;
  const CalendarCard = gbSc.div`
  width: 100%;
  min-width: 100%;
  max-width: 28rem;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0.75rem;
  margin: 0 auto;
  overflow: hidden;
`;
  const CalendarHeader = gbSc.div`
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.5rem;
  text-align: center;
`;

  // Filter non-DOM props (selected, btnColor) to avoid React warnings
  const TimeSlotButton = gbSc(function (props) {
    var selected = props.selected;
    var btnColor = props.btnColor;
    var rest = Object.assign({}, props);
    delete rest.selected;
    delete rest.btnColor;
    return React.createElement("button", rest);
  })`
  padding: 0.5rem;
  border-radius: 0.5rem;
  text-align: center;
  transition: all 200ms;
  width: 100%;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  color: #000;
  font-size: 1.125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  ${function (props) {
    return props.selected ? "background: var(--gb-btn-color, #3b82f6); color: var(--gb-text-color, white); border: 1px solid transparent;" : "&:hover { background: white; border-color: #bfdbfe; }";
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

  // Filter non-DOM prop (btnColor) to avoid React warnings
  const CheckoutButton = gbSc(function (props) {
    var btnColor = props.btnColor;
    var rest = Object.assign({}, props);
    delete rest.btnColor;
    return React.createElement("button", rest);
  })`
  /* Full reset + Grocerbox look: theme “checkout” classes are optional per-store
     and often missing, which leaves the OS default button. These rules match
     MethodButton / time slot chrome and inherit --gb-btn-color from Container. */
  box-sizing: border-box;
  display: block;
  width: 100%;
  margin-top: 1rem;
  padding: 0.875rem 1.25rem;
  font-size: 1.125rem;
  font-weight: 600;
  font-family: inherit;
  line-height: 1.25;
  text-align: center;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 0.5rem;
  border: 1px solid var(--gb-btn-color, #111827);
  background: var(--gb-btn-color, #111827);
  color: var(--gb-text-color, #ffffff);
  transition: filter 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);

  &:hover:not(:disabled) {
    filter: brightness(1.06);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }

  &:active:not(:disabled) {
    filter: brightness(0.96);
  }

  &:focus-visible {
    outline: 2px solid var(--gb-btn-color, #111827);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    filter: none;
    box-shadow: none;
    background: #9ca3af;
    border-color: #9ca3af;
    color: #ffffff;
  }
`;
  const LoadingSpinner = gbSc.div`
  z-index: 1000;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: rgb(255, 255, 255);
  opacity: 0.6;
  cursor: default;
  position: absolute;

  @keyframes spin {
    100% {
      transform:rotate(360deg);
    }
  }

  &:after {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -13px;
    margin-top: -13px;
    content: "";
    width: 26px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid #bbb;
    border-left-color: #000;
    border-radius: 50%;
    animation: spin 450ms infinite linear;
  }
`;
  const ServiceWindowBtn = gbSc.button`
  min-width: 8rem;
  max-width: 8rem;
  padding: 1rem 0;
  margin-right: 1rem;
  font-size: 1rem;
  text-align: center;
  transition: 50ms all ease-in-out;
  cursor: pointer;
  opacity: 0.5;
  border: 0;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
  }

  &.active {
    opacity: 1;
    background: var(--gb-btn-color, black);
    color: var(--gb-text-color, white);
  }
`;
  const ServiceWindowDate = gbSc.div`
  line-height: 1em;
  margin-top: 10px;
  font-size: 4rem;
  font-weight: bold;
`;
  const Input = gbSc.input`
  box-sizing: border-box;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.65rem 0.875rem;
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #111827;
  font-family: inherit;
  font-size: max(1rem, 16px);
  line-height: 1.4;
  appearance: none;
  -webkit-appearance: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: var(--gb-btn-color, #3b82f6);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    background: #f3f4f6;
  }
`;
  const MembershipInputContainer = gbSc.div`
  padding-top: 0.5rem;
  border-top: 1px solid #e5e7eb;
`;
  const GbFieldWrapper = gbSc.div`
  margin-bottom: 1rem;
  width: 100%;
`;
  const GbFormSectionLabel = gbSc.div`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.35;
  margin-bottom: 0.5rem;
  color: inherit;
`;
  const MembershipInput = function (props) {
    var value = props.value;
    var onChange = props.onChange;
    var onBlur = props.onBlur;
    var label = props.label;
    var placeholder = props.placeholder;
    var helpText = props.helpText;
    return React.createElement(MembershipInputContainer, null, React.createElement(GbFormSectionLabel, null, label), React.createElement(GbFieldWrapper, {
      style: {
        marginBottom: 0
      }
    }, React.createElement(Input, {
      type: "text",
      placeholder: placeholder,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      className: "gb-timeslots-input"
    }), helpText && React.createElement("p", {
      style: {
        marginTop: "0.5rem",
        color: "inherit",
        opacity: 0.82
      }
    }, React.createElement("small", null, helpText))));
  };
  const TextArea = gbSc.textarea`
  box-sizing: border-box;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.75rem 0.875rem;
  min-height: 5.5rem;
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #111827;
  font-family: inherit;
  font-size: max(1rem, 16px);
  line-height: 1.5;
  resize: vertical;
  appearance: none;
  -webkit-appearance: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: var(--gb-btn-color, #3b82f6);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    background: #f3f4f6;
  }
`;
  var GB_TIMESLOTS_SELECT_CHEVRON = "data:image/svg+xml;charset=utf-8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 7.5L10 12.5L15 7.5" stroke="#374151" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  const GbSelect = gbSc.select`
  box-sizing: border-box;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.65rem 2.35rem 0.65rem 0.875rem;
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
  background-color: #ffffff;
  color: #111827;
  font-family: inherit;
  font-size: max(1rem, 16px);
  line-height: 1.4;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${GB_TIMESLOTS_SELECT_CHEVRON});
  background-repeat: no-repeat;
  background-position: right 0.65rem center;
  background-size: 1.1rem 1.1rem;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--gb-btn-color, #3b82f6);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    background-color: #f3f4f6;
  }
`;
  const ButtonGroup = gbSc.div`
  display: flex;
  width: 100%;
`;
  // Filter non-DOM prop (active) to avoid React warnings
  const MethodButton = gbSc(function (props) {
    var active = props.active;
    var rest = Object.assign({}, props);
    delete rest.active;
    return React.createElement("button", rest);
  })`
  flex: 1;
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  transition: background .25s ease-in-out,color .25s ease-in-out,box-shadow .25s ease-in-out;
  border: 1px solid var(--gb-btn-color, black);
  background: ${function (props) {
    return props.active ? "var(--gb-btn-color, black)" : "white";
  }};
  color: ${function (props) {
    return props.active ? "var(--gb-text-color, white)" : "black";
  }}
`;
  const ServiceWindow = function (props) {
    var active = props.active;
    var loading = props.loading;
    var serviceWindow = props.window;
    var handleClick = props.handleClick;
    var btnColor = props.btnColor;
    var availableWindows = props.availableWindows;
    var activeMethod = props.activeMethod;

    // console.log("ServiceWindow props:", { active, window, availableWindows }); // Debug log

    const _React$useState = React.useState(function () {
      if (serviceWindow && serviceWindow.date) {
        // console.log("Initializing with window date:", serviceWindow.date); // Debug log
        const dateParts = serviceWindow.date.split("-");
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];
        return new Date(year, parseInt(month, 10) - 1, 1); // Set to first of the selected month
      }
      // console.log("Initializing with current date"); // Debug log
      return new Date();
    });
    const currentDate = _React$useState[0];
    const setCurrentDate = _React$useState[1];
    const _React$useState2 = React.useState(function () {
      if (serviceWindow && serviceWindow.date) {
        const dateParts = serviceWindow.date.split("-");
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];
        return new Date(year, parseInt(month, 10) - 1, parseInt(day, 10));
      }
      return null;
    });
    const selectedDate = _React$useState2[0];
    const setSelectedDate = _React$useState2[1];

    // Race fix (single-window auto-select, see date-button onClick below):
    // `loading` is driven asynchronously by CartJS's own cart.requestStarted /
    // cart.requestComplete jQuery events, not by anything synchronous at the
    // point of a click. If the customer taps a second (or third) single-window
    // date while an earlier tap's CartJS.setAttributes request is still in
    // flight, `loading` may already read true and the old `if (!loading)`
    // guard would silently DROP that tap instead of committing it.
    //
    // pendingWindowSelectionRef always holds the most recently tapped
    // single-window selection that hasn't been sent yet. The effect below
    // watches `loading` for its true -> false edge (the in-flight request just
    // settled) and, if the pending selection still doesn't match what's now
    // committed (serviceWindow), fires handleClick for it immediately. That
    // itself starts a new request, which flips `loading` true then false again,
    // so this naturally keeps "catching up" tap-by-tap until the pending
    // selection matches what's committed or there's nothing left pending —
    // i.e. the LAST tap always wins, never a stale one and never a dropped one.
    const pendingWindowSelectionRef = React.useRef(null);
    const wasLoadingRef = React.useRef(loading);

    // Race fix bug A: `loading` (passed in as `loading || cartLoading`) is a
    // SHARED flag — it also flips true/false on a fulfillment-method switch
    // (Pickup <-> Delivery, via getAvailableWindows inside setMethod) and on
    // any other unrelated CartJS request on the page, not just this
    // component's own window-selection request. If a single-window selection
    // is still queued in pendingWindowSelectionRef when the method changes,
    // the date/window it captured belongs to the OLD method's context and
    // must not be fired into the new one. Just drop it — don't fire anything
    // here, the settle effect below only ever fires what's still pending.
    React.useEffect(function () {
      pendingWindowSelectionRef.current = null;
    }, [activeMethod]);
    React.useEffect(function () {
      const wasLoading = wasLoadingRef.current;
      wasLoadingRef.current = loading;
      if (!wasLoading || loading) {
        // Only act on the true -> false edge (a request just settled).
        return;
      }
      const pending = pendingWindowSelectionRef.current;
      if (!pending) {
        return;
      }
      pendingWindowSelectionRef.current = null;
      if (!serviceWindow || serviceWindow.code !== pending.code) {
        // Race fix bug C: don't trust that `pending` is still a real,
        // current option just because it hasn't been fired yet. Re-derive
        // the live windows for pending's own date the same way the date-tap
        // handler does, and only fire if it's still (a) the date the
        // customer currently has selected and (b) still offered for that
        // date under the currently active method (availableWindows is
        // re-fetched per method, so this also guards a method switch that
        // slipped past the activeMethod effect above). Otherwise the
        // customer's UI state has moved on — drop it silently.
        var pendingDateParts = pending.date ? pending.date.split("-") : null;
        var pendingDateObj = pendingDateParts ? new Date(pendingDateParts[0], parseInt(pendingDateParts[1], 10) - 1, parseInt(pendingDateParts[2], 10)) : null;
        var pendingIsCurrentSelection = pendingDateObj && selectedDate && selectedDate.toDateString() === pendingDateObj.toDateString();
        var pendingStillOffered = pendingDateObj && getWindowsForDate(pendingDateObj).some(function (w) {
          return w.code === pending.code;
        });
        if (pendingIsCurrentSelection && pendingStillOffered) {
          handleClick(pending);
        }
      }
    }, [loading, serviceWindow, handleClick]);

    // Add useEffect to handle updates to window prop
    React.useEffect(function () {
      if (serviceWindow && serviceWindow.date) {
        const dateParts = serviceWindow.date.split("-");
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];
        setCurrentDate(new Date(year, parseInt(month, 10) - 1, 1));
        setSelectedDate(new Date(year, parseInt(month, 10) - 1, parseInt(day, 10)));
      }
    }, [serviceWindow]);

    // If the first bookable slots are in a later month (current month has no future days with windows),
    // move the calendar to that month. Skips when the cart already has a slot selected.
    React.useEffect(function () {
      if (!availableWindows || availableWindows.length === 0) {
        return;
      }
      if (serviceWindow && serviceWindow.date) {
        return;
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      function dayKey(d) {
        return d.toISOString().split("T")[0];
      }
      function viewMonthHasSelectableDay(viewYear, viewMonth) {
        var lastDayOfMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
        var day;
        for (day = 1; day <= lastDayOfMonth; day++) {
          var cell = new Date(viewYear, viewMonth, day);
          cell.setHours(0, 0, 0, 0);
          if (cell < today) {
            continue;
          }
          var key = dayKey(cell);
          var i;
          for (i = 0; i < availableWindows.length; i++) {
            if (availableWindows[i] && availableWindows[i].date === key) {
              return true;
            }
          }
        }
        return false;
      }
      setCurrentDate(function (prev) {
        var vy = prev.getFullYear();
        var vm = prev.getMonth();
        if (viewMonthHasSelectableDay(vy, vm)) {
          return prev;
        }
        var earliest = null;
        var j;
        for (j = 0; j < availableWindows.length; j++) {
          var win = availableWindows[j];
          if (!win || !win.date) {
            continue;
          }
          if (earliest === null || win.date < earliest) {
            earliest = win.date;
          }
        }
        if (!earliest) {
          return prev;
        }
        var parts = earliest.split("-");
        if (parts.length < 3) {
          return prev;
        }
        var ey = parseInt(parts[0], 10);
        var em = parseInt(parts[1], 10) - 1;
        if (!Number.isFinite(ey) || !Number.isFinite(em)) {
          return prev;
        }
        return new Date(ey, em, 1);
      });
    }, [availableWindows, serviceWindow]);
    React.useEffect(function () {
      const rootWindow = typeof window !== "undefined" ? window : undefined;
      if (!rootWindow) {
        return undefined;
      }
      const resizeHandler = function () {
        setCurrentDate(function (prev) {
          return new Date(prev);
        });
      };
      rootWindow.addEventListener("resize", resizeHandler);
      rootWindow.handleResize = resizeHandler;
      return function () {
        rootWindow.removeEventListener("resize", resizeHandler);
        if (rootWindow.handleResize === resizeHandler) {
          delete rootWindow.handleResize;
        }
      };
    }, []);
    const handlePrevMonth = function () {
      if (!isPrevMonthDisabled()) {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
      }
    };
    const handleNextMonth = function (e) {
      e.preventDefault();
      setCurrentDate(function (prev) {
        const newDate = new Date(prev);
        newDate.setMonth(prev.getMonth() + 1);
        return newDate;
      });
    };
    const renderCalendar = function () {
      const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      const days = [];
      const firstWeekday = Number.isFinite(firstDay.getDay()) ? firstDay.getDay() : 0;

      // Add the days of the month
      for (let day = 1; day <= lastDay.getDate(); day++) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        const isSelected = selectedDate && date.toDateString() === selectedDate.toDateString();

        // Check if date is in the past
        const isPastDate = date < new Date().setHours(0, 0, 0, 0);

        // Check if date has available windows
        const dateStr = date.toISOString().split("T")[0];
        const hasAvailableWindows = availableWindows.some(function (w) {
          return w.date === dateStr;
        });

        // Determine if the date should be disabled
        const isDisabled = isPastDate || !hasAvailableWindows;
        days.push(React.createElement("button", {
          key: day,
          type: "button",
          onClick: function (e) {
            e.preventDefault();
            if (!isDisabled) {
              setSelectedDate(date);
              // Customers pick a date and don't realize picking a time
              // window is a separate second tap, so they leave without
              // ever enabling checkout (Kalustyans "checkout button
              // greyed out" report). When the date they just picked has
              // exactly one available window, select it for them the
              // same way a real click on that window would — via the
              // same handleClick path used by TimeSlotButton below. If
              // there are 2+ windows, leave it alone: a real choice
              // between times shouldn't be made silently.
              var windowsForDate = getWindowsForDate(date);
              if (windowsForDate.length === 1) {
                if (!serviceWindow || serviceWindow.code !== windowsForDate[0].code) {
                  if (!loading) {
                    pendingWindowSelectionRef.current = null;
                    handleClick(windowsForDate[0]);
                  } else {
                    // A request from an earlier tap is still in flight.
                    // Record this as the latest intended selection; the
                    // loading-settle effect above fires it (and keeps
                    // catching up) once the in-flight request(s) resolve.
                    pendingWindowSelectionRef.current = windowsForDate[0];
                  }
                }
              } else {
                // Race fix bug B: this date tap resolved to 0 or 2+
                // windows, i.e. NOT the single-window auto-select case.
                // Any date tap invalidates a previously queued auto-select
                // intention that wasn't for this date — e.g. the customer
                // tapped an earlier single-window date while a request was
                // still in flight, then tapped this multi-window date
                // instead. Without this, the stale earlier selection would
                // still fire later even though the customer has moved on.
                pendingWindowSelectionRef.current = null;
              }
            }
          },
          disabled: isDisabled,
          style: {
            width: "100%",
            minWidth: "30px",
            maxWidth: "55px",
            aspectRatio: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: isDisabled ? "#ccc" : isSelected ? "white" : "black",
            cursor: isDisabled ? "not-allowed" : "pointer",
            fontSize: "1.25rem",
            borderRadius: "0.5rem",
            // Reset theme / UA button chrome — otherwise many themes apply a heavy
            // border (often matching accent/black) and it reads as a dark outline
            // instead of the subtle elevation used on CalendarCard.
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            border: isDisabled ? "1px solid #e5e7eb" : isSelected ? "1px solid transparent" : "1px solid #e5e7eb",
            boxShadow: isDisabled ? "none" : isSelected ? "0 1px 3px rgba(0, 0, 0, 0.12)" : "0 1px 3px rgba(0, 0, 0, 0.08)",
            background: isSelected ? "var(--gb-btn-color, #3b82f6)" : isDisabled ? "#f3f4f6" : "#f9fafb",
            transition: "all 200ms",
            gridColumnStart: day === 1 ? firstWeekday + 1 : undefined
          }
        }, day));
      }
      return days;
    };

    // Filter available windows for the selected date
    const getWindowsForDate = function (date) {
      if (!date || !availableWindows) return [];
      const dateStr = date.toISOString().split("T")[0];
      return availableWindows.filter(function (w) {
        return w.date === dateStr;
      }).sort(function (a, b) {
        var aStart = a.collection_time !== undefined && a.collection_time !== null ? a.collection_time : 0;
        var bStart = b.collection_time !== undefined && b.collection_time !== null ? b.collection_time : 0;
        if (aStart !== bStart) return aStart - bStart;
        // Secondary sort by due_time then name for stability
        var aEnd = a.due_time !== undefined && a.due_time !== null ? a.due_time : 0;
        var bEnd = b.due_time !== undefined && b.due_time !== null ? b.due_time : 0;
        if (aEnd !== bEnd) return aEnd - bEnd;
        return (a.name || "").localeCompare(b.name || "");
      });
    };

    // In the ServiceWindow component, add this function to check if previous month is disabled
    const isPrevMonthDisabled = function () {
      const today = new Date();
      const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
      return prevMonth.getMonth() < today.getMonth() && prevMonth.getFullYear() <= today.getFullYear();
    };
    return React.createElement(CalendarCard, null, React.createElement(CalendarHeader, null, React.createElement("h2", {
      style: {
        fontSize: "1.3rem",
        fontWeight: "700",
        color: "#1f2937"
      }
    }, "Select a time slot")), React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        backgroundColor: "#f3f4f6",
        padding: "1rem"
      }
    }, React.createElement("div", {
      style: {
        width: "100%"
      }
    }, React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1.5rem"
      }
    }, React.createElement("button", {
      type: "button",
      onClick: handlePrevMonth,
      disabled: isPrevMonthDisabled(),
      style: {
        padding: "0.5rem",
        borderRadius: "9999px",
        background: "none",
        border: "none",
        cursor: isPrevMonthDisabled() ? "not-allowed" : "pointer",
        fontSize: "1.2rem",
        opacity: isPrevMonthDisabled() ? 0.3 : 1,
        color: "#1f2937"
      }
    }, "←"), React.createElement("h3", {
      style: {
        fontSize: "1.1rem",
        fontWeight: "600",
        color: "#1f2937",
        margin: "0 auto"
      }
    }, currentDate.toLocaleString("default", {
      month: "long",
      year: "numeric"
    })), React.createElement("button", {
      type: "button",
      onClick: handleNextMonth,
      style: {
        padding: "0.5rem",
        borderRadius: "9999px",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "1.5rem",
        color: "#1f2937"
      }
    }, "→")), React.createElement("div", {
      style: {
        width: "100%",
        maxWidth: "400px",
        margin: "0 auto"
      }
    }, React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(7, minmax(30px, 1fr))",
        gap: "3px",
        justifyItems: "center",
        marginBottom: "8px"
      }
    }, ["S", "M", "T", "W", "T", "F", "S"].map(function (day, index) {
      return React.createElement("div", {
        key: "weekday-" + index,
        style: {
          width: "100%",
          minWidth: "30px",
          maxWidth: "55px",
          textAlign: "center",
          fontSize: "14px",
          color: "#666"
        }
      }, day);
    })), React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(7, minmax(30px, 1fr))",
        gap: "3px",
        justifyItems: "center"
      }
    }, renderCalendar()))), selectedDate && React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
      }
    }, React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        fontSize: "1.125rem",
        fontWeight: "600",
        color: "#374151"
      }
    }, React.createElement("span", null, "🕒"), React.createElement("h7", {
      style: {
        wordBreak: "break-word",
        fontSize: "1.15rem"
      }
    }, "Available times for ", selectedDate.toLocaleString("default", {
      weekday: "long",
      month: "long",
      day: "numeric"
    }))), React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
        gap: "8px",
        padding: "8px 0"
      }
    }, getWindowsForDate(selectedDate).map(function (timeWindow) {
      return React.createElement(TimeSlotButton, {
        key: timeWindow.code,
        selected: serviceWindow && serviceWindow.code === timeWindow.code,
        onClick: function () {
          handleClick(timeWindow);
        },
        disabled: loading,
        btnColor: btnColor
      }, timeWindow.name);
    })))));
  };

  // TODO: Add pickup/delivery selection based on config

  // Add the new components
  const Card = function (props) {
    var children = props.children;
    var className = props.className;
    if (className === undefined) className = "";
    return React.createElement("div", {
      className: "rounded-lg " + className
    }, children);
  };
  const CardHeader = function (props) {
    var children = props.children;
    var className = props.className;
    if (className === undefined) className = "";
    return React.createElement("div", {
      className: "p-4 flex items-center justify-center " + className
    }, children);
  };
  const CardTitle = function (props) {
    var children = props.children;
    var className = props.className;
    if (className === undefined) className = "";
    return React.createElement("h2", {
      className: "text-lg font-semibold " + className
    }, children);
  };
  const CardContent = function (props) {
    var children = props.children;
    var className = props.className;
    if (className === undefined) className = "";
    return React.createElement("div", {
      className: "p-6 " + className
    }, children);
  };
  function GrocerBoxComponent(props) {
    var config = props.config;
    const baseUri = config.mode === "dev" ? "https://grocerbox.ngrok.io" : "https://api.getgrocerbox.com";
    const shopify_domain = Shopify.shop.replace(".myshopify.com", "");
    const refundableHold = config.refundableHoldHandle;

    /**
     * Normalize GET .../available_windows into { windows, error }.
     *
     * An HTTP error or an unparseable body is reported as error:true and NEVER
     * as "zero availability" — the two must not be confused, because zero
     * availability is allowed to clear a saved slot and an error is not.
     */
    const parseAvailableWindowsResult = function (res) {
      if (!res.ok) {
        return res.text().then(function (t) {
          if (typeof console !== "undefined" && console.warn) {
            console.warn("[GrocerBox][TimeSlots] available_windows HTTP " + res.status, (t || "").slice(0, 240));
          }
          return {
            windows: [],
            error: true
          };
        }, function () {
          return {
            windows: [],
            error: true
          };
        });
      }
      return res.json().then(function (payload) {
        if (Array.isArray(payload)) {
          return {
            windows: payload,
            error: false
          };
        }
        if (payload && Array.isArray(payload.available_windows)) {
          return {
            windows: payload.available_windows,
            error: false
          };
        }
        if (payload != null && typeof console !== "undefined" && typeof console.warn === "function") {
          console.warn("[GrocerBox][TimeSlots] available_windows: expected JSON array or { available_windows: [] }, keys:", typeof payload === "object" ? Object.keys(payload) : typeof payload);
        }
        return {
          windows: [],
          error: true
        };
      }, function () {
        return {
          windows: [],
          error: true
        };
      });
    };

    /** Array-only view, kept so the non-Eataly render path is unchanged. */
    const parseAvailableWindowsResponse = function (res) {
      return parseAvailableWindowsResult(res).then(function (result) {
        return result.windows;
      });
    };
    const _React$useState3 = React.useState([]);
    const availableWindows = _React$useState3[0];
    const setAvailableWindows = _React$useState3[1];
    const _React$useState4 = React.useState(false);
    const loading = _React$useState4[0];
    const setLoading = _React$useState4[1];
    const _React$useState5 = React.useState(false);
    const loaded = _React$useState5[0];
    const setLoaded = _React$useState5[1];
    const _React$useState6 = React.useState([]);
    const serviceWindows = _React$useState6[0];
    const setServiceWindows = _React$useState6[1];
    const _React$useState7 = React.useState();
    const cart = _React$useState7[0];
    const setCart = _React$useState7[1];
    const _React$useState8 = React.useState(config.customerMembershipNumber || "");
    const membershipNumber = _React$useState8[0];
    const setMembershipNumber = _React$useState8[1];
    const _React$useStateEmail = React.useState(config.customerMemberEmail || "");
    const memberEmail = _React$useStateEmail[0];
    const setMemberEmail = _React$useStateEmail[1];
    const saveMembershipToBackend = function (value) {
      if (!config.customerEmail || !value) return;
      const shopDomain = Shopify.shop.replace(".myshopify.com", "");
      const url = baseUri + "/api/shops/" + shopDomain + "/customers/update_membership";
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: config.customerEmail,
          member_number: value
        })
      }).catch(function (err) {
        console.error("Error saving membership to backend:", err);
      });
    };
    const saveMemberEmailToBackend = function (value) {
      if (!config.customerEmail || !value) return;
      const shopDomain = Shopify.shop.replace(".myshopify.com", "");
      const url = baseUri + "/api/shops/" + shopDomain + "/customers/update_membership";
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: config.customerEmail,
          member_email: value
        })
      }).catch(function (err) {
        console.error("Error saving member email to backend:", err);
      });
    };
    const handleMembershipBlur = function (e) {
      const value = e.target.value;
      CartJS.setAttribute("Membership Number", value);

      // Auto-save to customer account if not already saved
      if (!config.customerMembershipNumber && value) {
        saveMembershipToBackend(value);
      }
    };
    const handleMemberEmailBlur = function (e) {
      const value = e.target.value;
      CartJS.setAttribute("Member Email", value);

      // Auto-save to customer account if not already saved
      if (!config.customerMemberEmail && value) {
        saveMemberEmailToBackend(value);
      }
    };
    const _React$useState9 = React.useState(false);
    const cartLoading = _React$useState9[0];
    const setCartLoading = _React$useState9[1];
    const initialCartMinimum = function () {
      const rawValue = config.cartMinimumCents;
      const parsed = parseInt(rawValue, 10);
      return Number.isFinite(parsed) ? parsed : 0;
    }();
    const _React$useState10 = React.useState(initialCartMinimum);
    const cartMinimumCents = _React$useState10[0];
    const setCartMinimumCents = _React$useState10[1];
    const shopifyCurrency = typeof window !== "undefined" && window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : "USD";
    const resolvedCurrency = (config.cartCurrency && typeof config.cartCurrency === "string" ? config.cartCurrency : null) || shopifyCurrency;
    const _React$useState11 = React.useState(resolvedCurrency);
    const cartCurrency = _React$useState11[0];
    const setCartCurrency = _React$useState11[1];
    const _React$useState12 = React.useState("delivery");
    const activeMethod = _React$useState12[0];
    const setActiveMethod = _React$useState12[1];
    const membershipSyncRef = React.useRef(false);
    const _React$useState13 = React.useState({
      pickup: true,
      delivery: true
    });
    const methodAvailability = _React$useState13[0];
    const setMethodAvailability = _React$useState13[1];
    const _React$useState14 = React.useState(false);
    const methodsReady = _React$useState14[0];
    const setMethodsReady = _React$useState14[1];

    // --- Eataly cart simplification state ---------------------------------
    // All of it is inert unless config.eatalyCartSimplification is true, but the
    // hooks are declared unconditionally so hook order never changes.
    const _eatalySlotModal = React.useState(false);
    const slotModalOpen = _eatalySlotModal[0];
    const setSlotModalOpen = _eatalySlotModal[1];
    const _eatalyStaged = React.useState(null);
    const stagedWindow = _eatalyStaged[0];
    const setStagedWindow = _eatalyStaged[1];
    const _eatalyConfirming = React.useState(false);
    const confirmingSlot = _eatalyConfirming[0];
    const setConfirmingSlot = _eatalyConfirming[1];
    const _eatalySlotError = React.useState(null);
    const slotError = _eatalySlotError[0];
    const setSlotError = _eatalySlotError[1];
    const _eatalyTimezone = React.useState(config.shopTimezone || config.storeTimezone || config.timezone || null);
    const storeTimezone = _eatalyTimezone[0];
    const setStoreTimezone = _eatalyTimezone[1];
    const _eatalyAvailabilityError = React.useState(false);
    const availabilityError = _eatalyAvailabilityError[0];
    const setAvailabilityError = _eatalyAvailabilityError[1];
    const _eatalyNotes = React.useState(null);
    const notes = _eatalyNotes[0];
    const setNotes = _eatalyNotes[1];
    const _eatalySavedNotes = React.useState(null);
    const setSavedNotes = _eatalySavedNotes[1];
    const _eatalyNotesError = React.useState(null);
    const notesError = _eatalyNotesError[0];
    const setNotesError = _eatalyNotesError[1];
    const _eatalyCheckoutError = React.useState(null);
    const checkoutError = _eatalyCheckoutError[0];
    const setCheckoutError = _eatalyCheckoutError[1];
    const _eatalyAutoSelectError = React.useState(false);
    const autoSelectError = _eatalyAutoSelectError[0];
    const setAutoSelectError = _eatalyAutoSelectError[1];
    const _eatalyNotesSaving = React.useState(false);
    const notesSaving = _eatalyNotesSaving[0];
    const setNotesSaving = _eatalyNotesSaving[1];
    const _eatalyNotesMount = React.useState(function () {
      return typeof document !== "undefined" ? document.getElementById("gb-cart-notes") : null;
    });
    const notesMount = _eatalyNotesMount[0];
    const notesRef = React.useRef(null);
    const savedNotesRef = React.useRef(null);
    const confirmingSlotRef = React.useRef(false);
    const checkoutBusyRef = React.useRef(false);
    // One serialised lane for every cart write the notes panel makes.
    const notesQueueRef = React.useRef(null);
    if (notesQueueRef.current === null) {
      notesQueueRef.current = typeof window !== "undefined" && window.EatalyCart ? window.EatalyCart.createWriteQueue() : function (task) {
        return Promise.resolve().then(task);
      };
    }
    const allowCheckoutSubmitRef = React.useRef(false);
    const checkoutButtonRef = React.useRef(null);
    const dialogRef = React.useRef(null);
    const changeButtonRef = React.useRef(null);
    const autoSelectedRef = React.useRef(false);
    const eatalyHelpers = typeof window !== "undefined" ? window.EatalyCart : null;
    const eatalySimplified = config.eatalyCartSimplification === true || typeof window !== "undefined" && !!window.gbTimeSlotsConfig && window.gbTimeSlotsConfig.eatalyCartSimplification === true;
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const WINDOW_NAME_KEY = "window";
    const WINDOW_CODE_KEY = "code";
    const DATE_KEY = "Date";
    const DELIVERY_NOTE = "Delivery Note";
    const SUBSTITUTIONS = "Substitutions";
    const METHOD_KEY = "Method";
    const PICKUP_METHOD = "pickup";
    const DELIVERY_METHOD = "delivery";
    const SHIPPING_METHOD = "shipping";
    let flkty = null;
    const allowSelectingMethod = config.allowSelectingMethod;
    /** When `allowSelectingMethod` is true: Shipping tab only if `showShippingMethod === true` (opt-in). Omitted or false → pickup + local delivery only. */
    const showShippingMethod = config.showShippingMethod === true;
    const normalizeMethod = function (value) {
      if (!value) {
        return null;
      }
      const normalized = value.toString().toLowerCase();
      if ([PICKUP_METHOD, DELIVERY_METHOD, SHIPPING_METHOD].indexOf(normalized) === -1) {
        return null;
      }
      if (!allowSelectingMethod && normalized === SHIPPING_METHOD) {
        return null;
      }
      if (!showShippingMethod && normalized === SHIPPING_METHOD) {
        return null;
      }
      return normalized;
    };
    const collectionsToCompare = (config.collectionsThatCantBeSoldAlone || []).map(function (x) {
      return x.toLowerCase();
    }).filter(function (c) {
      return (config.collectionsToIgnore || []).indexOf(c) === -1;
    });
    let cannotBeSoldAlone = Object.keys(config.cartItemCollections || {}).length === 0 ? false : true;
    Object.keys(config.cartItemCollections || {}).forEach(function (key) {
      let collections = config.cartItemCollections[key];
      let containsCollection = collections.filter(function (c) {
        return collectionsToCompare.indexOf(c.toLowerCase()) !== -1;
      }).length > 0;
      if (containsCollection === false) {
        cannotBeSoldAlone = false;
      }
    });

    /*
     * Alcohol / food policy. Off unless the cart section says it is on, in
     * which case it replaces the legacy collection rule above outright — the
     * disabled checkout, the submit guard, the button label and the blocked
     * reason all already hang off `cannotBeSoldAlone`, so reassigning it is the
     * whole integration. With the setting off nothing below changes and the
     * legacy behaviour is untouched.
     *
     * Read from the DOM on every render: the theme swaps this section's
     * innerHTML on each cart change, so the JSON is always current and a value
     * captured at mount would be a stale classification.
     */
    const foodPolicy = eatalyHelpers && eatalyHelpers.resolveFoodPolicy ? eatalyHelpers.resolveFoodPolicy(typeof document !== "undefined" ? document.querySelector("[data-eataly-food-policy]") : null) : {
      enabled: false,
      needsFood: false
    };
    if (foodPolicy.enabled) {
      cannotBeSoldAlone = foodPolicy.needsFood;
    }

    // Effects
    React.useEffect(function () {
      // Determine which methods are actually available (have windows)
      const collectionsParam = encodeURIComponent((config.cartCollections || []).filter(function (item, index) {
        return config.cartCollections.indexOf(item) === index;
      }).join(","));
      Promise.all([get("shopify/private_shops/" + encodeURIComponent(shopify_domain) + "/available_windows?method=" + PICKUP_METHOD + "&collections=" + collectionsParam).then(parseAvailableWindowsResponse).catch(function () {
        return [];
      }), get("shopify/private_shops/" + encodeURIComponent(shopify_domain) + "/available_windows?method=" + DELIVERY_METHOD + "&collections=" + collectionsParam).then(parseAvailableWindowsResponse).catch(function () {
        return [];
      })]).then(function (results) {
        const pickupWindows = results[0];
        const deliveryWindows = results[1];
        const pickupEnabled = Array.isArray(pickupWindows) && pickupWindows.length > 0;
        const deliveryEnabled = Array.isArray(deliveryWindows) && deliveryWindows.length > 0;
        if (!pickupEnabled && !deliveryEnabled && typeof console !== "undefined" && typeof console.info === "function") {
          console.info("[GrocerBox][TimeSlots] API returned no pickup or delivery windows. In GrocerBox admin check: pickup/delivery enabled, weekly schedule + calendar (open days / windows), window count > 0; availability rules on collections can filter all dates out.", {
            shop: shopify_domain,
            cartCollections: (config.cartCollections || []).length
          });
        }
        setMethodAvailability({
          pickup: pickupEnabled,
          delivery: deliveryEnabled
        });
        (function reconcileMethod() {
          const prev = typeof activeMethod === "string" ? activeMethod : DELIVERY_METHOD;
          let next = prev;
          if (prev === PICKUP_METHOD && !pickupEnabled && deliveryEnabled) next = DELIVERY_METHOD;else if (prev === DELIVERY_METHOD && !deliveryEnabled && pickupEnabled) next = PICKUP_METHOD;else if (!pickupEnabled && deliveryEnabled) next = DELIVERY_METHOD;else if (!deliveryEnabled && pickupEnabled) next = PICKUP_METHOD;
          if (next !== prev) {
            setMethod(next);
          } else {
            setActiveMethod(prev);
          }
        })();
      }).catch(function () {
        // leave defaults if check fails
      }).finally(function () {
        setMethodsReady(true);
      });
      $(function () {
        const cartPromise = CartJS.getCart();
        if (cartPromise) {
          cartPromise.then(function (c) {
            setCart(c);
          });
        }
      });
      $(document).on("cart.requestStarted", function (event, c) {
        setCartLoading(true);
      });
      $(document).on("cart.requestComplete", function (event, c) {
        setCartLoading(false);
        setCart(Object.assign({}, c));
        if (c && c.attributes) {
          if (c.attributes["Membership Number"] !== undefined) {
            setMembershipNumber(c.attributes["Membership Number"] || "");
          }
          if (c.attributes["Member Email"] !== undefined) {
            setMemberEmail(c.attributes["Member Email"] || "");
          }
        }
      });
    }, []);
    React.useEffect(function () {
      const currentAttr = cart && cart.attributes ? cart.attributes["Membership Number"] : undefined;
      if (config.customerMembershipNumber && cart && cart.attributes && !currentAttr && !membershipSyncRef.current) {
        membershipSyncRef.current = true;
        console.info("[GrocerBox] Pre-filling membership number from customer account");
        CartJS.setAttribute("Membership Number", config.customerMembershipNumber);
      }
      const currentEmailAttr = cart && cart.attributes ? cart.attributes["Member Email"] : undefined;
      if (config.customerMemberEmail && cart && cart.attributes && !currentEmailAttr) {
        console.info("[GrocerBox] Pre-filling member email from customer account");
        CartJS.setAttribute("Member Email", config.customerMemberEmail);
      }
    }, [cart, config.customerMembershipNumber, config.customerMemberEmail]);
    React.useEffect(function () {
      const controller = new AbortController();
      const cartConfigUrl = baseUri + "/shopify/private_shops/" + encodeURIComponent(shopify_domain) + "/cart_config";
      fetch(cartConfigUrl, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        signal: controller.signal
      }).then(function (response) {
        if (response.status === 404) {
          return null;
        }
        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }
        return response.json();
      }).then(function (data) {
        if (!data || typeof data !== "object") {
          return;
        }
        if (typeof data.cart_minimum_cents === "number") {
          setCartMinimumCents(Number.isFinite(data.cart_minimum_cents) ? data.cart_minimum_cents : 0);
        }
        if (data.currency && typeof data.currency === "string" && data.currency.length) {
          setCartCurrency(data.currency);
        }
      }).catch(function (error) {
        if (error && error.name === "AbortError") {
          return;
        }
        if (error && typeof error.message === "string" && error.message.indexOf("HTTP 404") !== -1) {
          return;
        }
        if (typeof console !== "undefined" && typeof console.warn === "function") {
          console.warn("[GrocerBox][CartMinimum] Unable to load cart configuration", error);
        }
      });
      return function () {
        return controller.abort();
      };
    }, [baseUri, shopify_domain]);
    React.useEffect(function () {
      // The simplified cart has no .window-carousel to mount Flickity on.
      if (!eatalySimplified && availableWindows.length > 0 && !flkty) {
        let initialIndex = 0;
        if (cart && cart.attributes && cart.attributes[WINDOW_CODE_KEY]) {
          initialIndex = availableWindows.map(function (w) {
            return w.code;
          }).indexOf(cart.attributes[WINDOW_CODE_KEY]);
        }
        setTimeout(function () {
          flkty = new Flickity(".window-carousel", {
            cellAlign: "left",
            draggable: true,
            initialIndex: initialIndex,
            pageDots: false
          });
        }, 0);
      }
    }, [availableWindows]);
    React.useEffect(function () {
      generateServiceWindows();
    }, [availableWindows]);
    React.useEffect(function () {
      if (methodsReady && !methodAvailability.pickup && !methodAvailability.delivery && !allowSelectingMethod) {
        return;
      }
      if (!cart || loading || cartLoading || loaded) {
        return;
      }
      const methodFromCart = normalizeMethod(cart && cart.attributes ? cart.attributes[METHOD_KEY] : null);
      let methodToUse = methodFromCart || activeMethod;
      if (methodToUse === SHIPPING_METHOD && !showShippingMethod) {
        if (methodAvailability.delivery) {
          methodToUse = DELIVERY_METHOD;
        } else if (methodAvailability.pickup) {
          methodToUse = PICKUP_METHOD;
        } else {
          methodToUse = DELIVERY_METHOD;
        }
      }
      if (methodToUse === PICKUP_METHOD && !methodAvailability.pickup && methodAvailability.delivery) {
        methodToUse = DELIVERY_METHOD;
      } else if (methodToUse === DELIVERY_METHOD && !methodAvailability.delivery && methodAvailability.pickup) {
        methodToUse = PICKUP_METHOD;
      }
      if (methodToUse !== activeMethod) {
        setMethod(methodToUse);
      }
      if (availableWindows.length === 0) {
        getAvailableWindows(cart, methodToUse);
      }
    }, [cart]);
    React.useEffect(function () {
      try {
        if (!cart || !cart.attributes) return;
        const current = normalizeMethod(cart.attributes[METHOD_KEY]);
        const desired = normalizeMethod(activeMethod);
        if (desired && current !== desired) {
          var attrs = {};
          attrs[METHOD_KEY] = desired;
          if (desired === SHIPPING_METHOD) {
            attrs[DATE_KEY] = null;
            attrs[WINDOW_NAME_KEY] = null;
            attrs[WINDOW_CODE_KEY] = null;
          }
          CartJS.setAttributes(attrs);
        }
      } catch (_) {}
    }, [activeMethod]);

    /** Drop slot attributes when cart is nationwide shipping (reload / external cart updates). */
    React.useEffect(function () {
      try {
        if (!cart || !cart.attributes) return;
        const m = normalizeMethod(cart.attributes[METHOD_KEY]);
        if (m !== SHIPPING_METHOD) return;
        if (cart.attributes[WINDOW_CODE_KEY] || cart.attributes[DATE_KEY] || cart.attributes[WINDOW_NAME_KEY]) {
          var clearSlot = {};
          clearSlot[DATE_KEY] = null;
          clearSlot[WINDOW_NAME_KEY] = null;
          clearSlot[WINDOW_CODE_KEY] = null;
          CartJS.setAttributes(clearSlot);
        }
      } catch (_) {}
    }, [cart]);
    React.useEffect(function () {
      if (!cart) {
        return;
      }
      const methodFromCart = normalizeMethod(cart && cart.attributes ? cart.attributes[METHOD_KEY] : null);
      if (methodFromCart && methodFromCart !== activeMethod) {
        setActiveMethod(methodFromCart);
      }
    }, [cart, activeMethod]);

    // enforcePickupOnly (per-store, default off): mirror the fulfillment choice onto a
    // hidden `_gb_method` line-item property so the CarrierService rate callback can see
    // it (cart ATTRIBUTES are not in the rate payload; line-item PROPERTIES are). The
    // server (ParseItems + Request) then hides delivery rates when pickup is chosen. No-op
    // unless the store opts in, so other stores' checkouts are unchanged.
    const writeMethodLineItemProperty = function (cartObj, methodValue) {
      if (!config.enforcePickupOnly) return;
      if (!cartObj || !Array.isArray(cartObj.items) || cartObj.items.length === 0) return;
      const normalized = normalizeMethod(methodValue) || DELIVERY_METHOD;
      // Shopify's CarrierService payload only includes shippable lines, so the property
      // must live on one: fee lines (requires_shipping=false, added first by grocerbox.js)
      // never reach the rate callback. Prefer a real product line; fall back to anything.
      const eligible = cartObj.items.filter(function (it) {
        return it && it.requires_shipping !== false && !(it.properties && it.properties._gb_fee);
      });
      const pool = eligible.length > 0 ? eligible : cartObj.items;
      const existing = pool.find(function (it) {
        return it && it.properties && it.properties._gb_method;
      });
      // Already correct -> skip the write so we don't loop on cart.requestComplete.
      if (existing && existing.properties._gb_method === normalized) return;
      const target = existing || pool[0];
      const lineNumber = cartObj.items.indexOf(target) + 1;
      const properties = Object.assign({}, target.properties || {}, {
        _gb_method: normalized
      });
      try {
        CartJS.updateItem(lineNumber, target.quantity, properties, {
          success: function () {},
          error: function () {}
        });
      } catch (_) {}
    };
    React.useEffect(function () {
      if (!config.enforcePickupOnly || !cart) return;
      const m = normalizeMethod(cart.attributes ? cart.attributes[METHOD_KEY] : null);
      if (m) writeMethodLineItemProperty(cart, m);
    }, [cart]);
    const get = function (path) {
      if (path === undefined) path = "";
      return fetch(baseUri + "/" + path, {
        method: "GET",
        mode: "cors",
        cache: "no-cache"
      });
    };
    const getAvailableWindows = function (currentCart, method) {
      if (method === undefined) method = activeMethod;
      const normalizedMethod = normalizeMethod(method) || DELIVERY_METHOD;
      setLoading(true);
      setLoaded(false);
      setActiveMethod(normalizedMethod);
      get("shopify/private_shops/" + encodeURIComponent(shopify_domain) + "/available_windows?method=" + normalizedMethod + "&collections=" + encodeURIComponent((config.cartCollections || []).filter(function (item, index) {
        return config.cartCollections.indexOf(item) === index;
      }).join(","))).then(parseAvailableWindowsResult).then(function (result) {
        const windowsArray = result.windows;
        if (result.error) {
          // The server did not tell us there are no windows — it failed to tell
          // us anything. Keep whatever we already had, flag the failure, and
          // above all do not clear a saved slot off the back of it.
          setAvailabilityError(true);
          return;
        }
        let timezoneFromWindows = null;
        for (let i = 0; i < windowsArray.length; i += 1) {
          const candidate = windowsArray[i];
          if (candidate && typeof candidate.timezone === "string" && candidate.timezone.length) {
            timezoneFromWindows = candidate.timezone;
            break;
          }
        }
        const timezoneFromConfig = config.shopTimezone || config.storeTimezone || config.timezone || null;
        const storeTimezone = timezoneFromWindows || timezoneFromConfig;
        if (storeTimezone) {
          // Kept in state so the delivery summary can label dates in the
          // store's own time zone rather than the shopper's.
          setStoreTimezone(storeTimezone);
        }
        if (typeof console !== "undefined" && typeof console.info === "function") {
          const now = new Date();
          let localizedTime = now.toISOString();
          if (storeTimezone && typeof Intl !== "undefined" && Intl.DateTimeFormat) {
            try {
              localizedTime = new Intl.DateTimeFormat("en-CA", {
                timeZone: storeTimezone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              }).format(now);
            } catch (err) {
              localizedTime = now.toISOString() + " (timezone format failed for " + storeTimezone + ")";
            }
          }
          const todaysDate = new Date().toISOString().split("T")[0];
          const hasSameDayWindow = windowsArray.some(function (w) {
            return w && w.date === todaysDate;
          });
          console.info("[GrocerBox][TimeSlots] Fetched available windows", {
            method: normalizedMethod,
            count: windowsArray.length,
            storeTimezone: storeTimezone || "unknown",
            storeTime: localizedTime,
            sameDayWindowPresent: hasSameDayWindow
          });
          if (windowsArray.length === 0) {
            console.info("[GrocerBox][TimeSlots] Zero windows for method=" + normalizedMethod + " — if HTTP was 200, the server filtered them out (disabled method, empty schedule, limits/cutoffs, or collection availability rules).");
          }
        }
        setAvailableWindows(windowsArray);
        setAvailabilityError(false);
        const currentCartDate = currentCart && currentCart.attributes ? currentCart.attributes[DATE_KEY] : null;
        if (currentCartDate && !windowsArray.find(function (w) {
          return w.date === currentCartDate;
        })) {
          var clearAttrs = {};
          clearAttrs[DATE_KEY] = null;
          clearAttrs[WINDOW_NAME_KEY] = null;
          clearAttrs[WINDOW_CODE_KEY] = null;
          CartJS.setAttributes(clearAttrs);
        }
      }).catch(function (error) {
        setAvailabilityError(true);
        handleError("GrocerBox: Error fetching available windows: " + error);
      }).finally(function () {
        setLoading(false);
        setLoaded(true);
      });
    };
    var _gbWriteTimer = null;
    var _gbWritePending = null;
    const writeGbLineItemProperty = function (currentCart, code, windowName, method) {
      if (config.enableLineItemGbProperty !== true) {
        return;
      }
      if (!currentCart || !Array.isArray(currentCart.items) || currentCart.items.length === 0) {
        return;
      }
      var payload = {};
      if (code) payload.code = code;
      if (windowName) payload.windowName = windowName;
      if (method) payload.method = method;
      if (!payload.code && !payload.method) return;
      var encoded = btoa(JSON.stringify(payload));
      var targetItem = null;
      for (var i = 0; i < currentCart.items.length; i++) {
        var item = currentCart.items[i];
        if (item.handle === refundableHold) continue;
        if (item.properties && item.properties._gb_fee) continue;
        targetItem = item;
        break;
      }
      if (!targetItem) return;
      var existingGb = targetItem.properties && targetItem.properties._gb;
      if (existingGb === encoded) return;
      _gbWritePending = {
        line: targetItem.id,
        encoded: encoded,
        quantity: targetItem.quantity
      };
      if (_gbWriteTimer) clearTimeout(_gbWriteTimer);
      _gbWriteTimer = setTimeout(function () {
        var pending = _gbWritePending;
        _gbWritePending = null;
        _gbWriteTimer = null;
        if (!pending) return;
        var props = Object.assign({}, targetItem.properties || {}, {
          _gb: pending.encoded
        });
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: pending.line,
            quantity: pending.quantity,
            properties: props
          })
        }).catch(function (err) {
          if (typeof console !== "undefined") console.warn("[GrocerBox] _gb write failed", err);
        });
      }, 300);
    };
    const selectWindow = function (window) {
      var attrs = {};
      attrs[DATE_KEY] = window.date;
      attrs[WINDOW_CODE_KEY] = window.code;
      attrs[WINDOW_NAME_KEY] = window.name;
      CartJS.setAttributes(attrs);
      writeGbLineItemProperty(cart, window.code, window.name, activeMethod);
    };
    const handleError = function (error) {
      setLoading(false);
    };
    const generateServiceWindows = function () {
      setServiceWindows(availableWindows.map(formatWindow));
    };
    const setMethod = function (method) {
      const normalized = normalizeMethod(method) || DELIVERY_METHOD;
      setActiveMethod(normalized);
      if (cart) {
        getAvailableWindows(cart, normalized);
      }
      var attrs = {};
      attrs[METHOD_KEY] = normalized;
      if (normalized === SHIPPING_METHOD) {
        attrs[DATE_KEY] = null;
        attrs[WINDOW_NAME_KEY] = null;
        attrs[WINDOW_CODE_KEY] = null;
      }
      CartJS.setAttributes(attrs);
      writeMethodLineItemProperty(cart, normalized);
      var currentCode;
      var currentName;
      if (normalized === SHIPPING_METHOD) {
        currentCode = null;
        currentName = null;
      } else {
        currentCode = cart && cart.attributes ? cart.attributes[WINDOW_CODE_KEY] : null;
        currentName = cart && cart.attributes ? cart.attributes[WINDOW_NAME_KEY] : null;
      }
      writeGbLineItemProperty(cart, currentCode, currentName, normalized);
    };
    const formatWindow = function (window) {
      const dateParts = window.date.split("-");
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];
      const date = new Date(year, parseInt(month, 10) - 1, day);
      return {
        window: window,
        code: window.code,
        day: weekdays[date.getDay()],
        month: months[date.getMonth()],
        date: date.getDate(),
        name: window.name
      };
    };
    const selectedWindow = cart && cart.attributes && cart.attributes[WINDOW_CODE_KEY] ? availableWindows.find(function (w) {
      return cart.attributes[WINDOW_CODE_KEY] === w.code;
    }) : null;
    const selected = selectedWindow ? formatWindow(selectedWindow) : null;
    const cartTotalCents = cart && typeof cart.total_price === "number" ? cart.total_price : 0;
    const cartBelowMinimum = cartMinimumCents > 0 && cartTotalCents < cartMinimumCents;
    const cartMinimumShortfall = cartBelowMinimum ? Math.max(0, cartMinimumCents - cartTotalCents) : 0;
    const isShippingOrder = activeMethod === SHIPPING_METHOD;
    const isPickupOrder = activeMethod === PICKUP_METHOD;
    const isLocalDelivery = activeMethod === DELIVERY_METHOD;

    /** Pickup / local delivery need a slot; nationwide shipping does not (calendar is hidden). */
    const timeslotRequired = !isShippingOrder && !!cart && !!cart.attributes && (!cart.attributes[WINDOW_CODE_KEY] || !selectedWindow);
    const checkoutDisabled = loading || cartLoading || !cart || !cart.attributes || timeslotRequired || cart.items.length === 1 && cart.items.find(function (item) {
      return item.handle === refundableHold;
    }) || cannotBeSoldAlone || cartBelowMinimum;

    /**
     * Everything that must stop a checkout submit, including the cases the
     * original disabled flag ignores: availability that failed to load (so the
     * windows we hold are stale) and a closed store. Checked in the submit
     * handler as well as on the button, because keyboard and programmatic
     * submits never consult `disabled`.
     */
    const noMethodsAvailable = methodsReady && !methodAvailability.pickup && !methodAvailability.delivery;
    const storeClosedForOrders = noMethodsAvailable && (!allowSelectingMethod || !showShippingMethod);
    const availabilityStale = !isShippingOrder && (availabilityError || !loaded);
    const eatalyCheckoutBlocked = checkoutDisabled || availabilityStale || storeClosedForOrders;
    const checkoutBlockedReason = function () {
      if (storeClosedForOrders) {
        return "We are not accepting orders right now. Please check back later.";
      }
      if (availabilityError) {
        return "We could not load " + (isPickupOrder ? "pickup" : "delivery") + " times. Check your connection and try again.";
      }
      if (!loaded || loading || cartLoading) {
        return "Still loading your cart. Please try again in a moment.";
      }
      if (cannotBeSoldAlone) {
        return foodPolicy.enabled ? "All alcohol purchases on Eataly.ca must be accompanied by a food item. Please add a food item to your purchase to continue to checkout. You must be 19+ years old to purchase alcohol and valid identification will be required upon delivery." : "Please add a food item to your cart before checking out.";
      }
      if (cartBelowMinimum) {
        return "Please add more items to reach the minimum order before checking out.";
      }
      if (timeslotRequired) {
        return "Please choose a " + (isPickupOrder ? "pickup" : "delivery") + " date and time before checking out.";
      }
      return "We cannot start checkout yet. Please review your cart.";
    }();
    const formatCurrency = React.useCallback(function (amountCents) {
      const fallbackCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "USD";
      const currencyCode = cart && cart.currency || cartCurrency || fallbackCurrency;
      if (!Number.isFinite(amountCents)) {
        amountCents = 0;
      }
      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amountCents / 100);
      } catch (_error) {
        return currencyCode + " " + (amountCents / 100).toFixed(2);
      }
    }, [cart, cartCurrency]);

    /* =====================================================================
     * EATALY CART SIMPLIFICATION
     *
     * Gated on config.eatalyCartSimplification. Replaces the always-open
     * calendar with a delivery summary + staged-change dialog, and moves the
     * notes fields into a collapsed accordion above checkout. Every other
     * store keeps the original render path untouched.
     * ===================================================================== */
    const DEFAULT_SUBSTITUTION = "Allow Substitutions (Don't Call)";
    const NOTES_SAVE_ERROR = "We could not save your order notes. Please try again.";
    const FOCUSABLE = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
    const serviceLabel = isPickupOrder ? "pickup" : "delivery";
    const cartUpdateUrl = (typeof window !== "undefined" && window.routes && window.routes.cartUrl ? window.routes.cartUrl : config.shopifyCartUrl || "/cart") + "/update.js";
    const readNotesFromCart = function (currentCart) {
      const attrs = currentCart && currentCart.attributes ? currentCart.attributes : {};
      return {
        note: currentCart && currentCart.note ? currentCart.note : "",
        deliveryNote: attrs[DELIVERY_NOTE] || "",
        substitutions: attrs[SUBSTITUTIONS] || DEFAULT_SUBSTITUTION
      };
    };
    const collectionsQueryParam = function () {
      return encodeURIComponent((config.cartCollections || []).filter(function (item, index) {
        return config.cartCollections.indexOf(item) === index;
      }).join(","));
    };

    // Mirror the cart's saved notes into state. The customer's in-progress
    // edits are seeded once and never clobbered by a later cart refresh.
    React.useEffect(function () {
      if (!eatalySimplified || !cart) {
        return;
      }
      const fromCart = readNotesFromCart(cart);
      savedNotesRef.current = fromCart;
      setSavedNotes(fromCart);
      if (notesRef.current === null) {
        notesRef.current = fromCart;
        setNotes(fromCart);
      }
    }, [eatalySimplified, cart]);

    // Auto-select the first eligible slot — but only once, only when real
    // availability has loaded for a known method, and never over a slot the
    // customer already has saved.
    React.useEffect(function () {
      if (!eatalySimplified || !eatalyHelpers) {
        return;
      }
      if (!methodsReady || !loaded || loading || cartLoading) {
        return;
      }
      if (isShippingOrder || autoSelectedRef.current) {
        return;
      }
      // A saved slot that is still offered wins. An expired one (cutoff passed,
      // window full) must not block this, or the cart sits on "Not selected yet".
      if (!cart || !cart.attributes || selectedWindow) {
        return;
      }
      if (!availableWindows.length) {
        return;
      }
      if (availabilityError) {
        return;
      }
      const first = eatalyHelpers.firstAvailableWindow(availableWindows);
      if (!first) {
        return;
      }
      // Set the guard before the write, not after: a failed write must surface
      // as something the shopper can retry by hand, never as a retry loop.
      autoSelectedRef.current = true;
      setAutoSelectError(false);
      writeSlotAttributes(first).then(null, function () {
        setAutoSelectError(true);
      });
    }, [eatalySimplified, methodsReady, loaded, loading, cartLoading, isShippingOrder, availabilityError, cart, availableWindows]);

    // Dialog chrome: lock the page behind it, move focus in, hand it back.
    React.useEffect(function () {
      if (!slotModalOpen || typeof document === "undefined") {
        return undefined;
      }
      const previousOverflow = document.body.style.overflow;
      const previouslyFocused = document.activeElement;
      document.body.style.overflow = "hidden";
      if (dialogRef.current) {
        dialogRef.current.focus();
      }
      return function () {
        document.body.style.overflow = previousOverflow;
        const changeButton = changeButtonRef.current;
        const restoreTo = changeButton && document.contains(changeButton) ? changeButton : previouslyFocused;
        if (restoreTo && typeof restoreTo.focus === "function") {
          restoreTo.focus();
        }
      };
    }, [slotModalOpen]);

    // The substitution footnote in the product card is rendered by Liquid in all
    // three variants; show the one that matches the current preference so it
    // never contradicts a shopper who picked "No Substitutions".
    React.useEffect(function () {
      if (!eatalySimplified || typeof document === "undefined") {
        return;
      }
      const active = notes && notes.substitutions ? notes.substitutions : DEFAULT_SUBSTITUTION;
      const nodes = document.querySelectorAll("[data-eataly-substitution-note]");
      for (let i = 0; i < nodes.length; i += 1) {
        nodes[i].hidden = nodes[i].getAttribute("data-eataly-substitution-note") !== active;
      }
    }, [eatalySimplified, notes]);

    // Keep the Liquid-rendered summary honest between section reloads: CartJS
    // mutations (refundable-hold adjustments, line-item property writes) update
    // the cart without re-rendering the section.
    React.useEffect(function () {
      if (!eatalySimplified || !eatalyHelpers || !cart || typeof document === "undefined") {
        return;
      }
      const panel = document.querySelector("[data-eataly-summary]");
      if (!panel) {
        return;
      }
      const totals = eatalyHelpers.summaryTotals(cart, refundableHold);
      const holdElement = panel.querySelector("[data-eataly-hold-price]");
      if (totals.hold > 0 && !holdElement) {
        // The hold row isn't on the page yet; the pending section reload will
        // render it. Updating Products alone here would stop reconciling.
        return;
      }
      const moneyFormat = typeof window !== "undefined" && window.theme ? window.theme.moneyFormat : null;
      const write = function (selector, cents) {
        const element = panel.querySelector(selector);
        if (element) {
          element.textContent = eatalyHelpers.formatMoney(cents, moneyFormat);
        }
      };
      write("[data-eataly-products-price]", totals.products);
      write("[data-eataly-hold-price]", totals.hold);
      write("[data-eataly-total-price]", totals.estimatedTotal);
      panel.setAttribute("data-products", totals.products);
      panel.setAttribute("data-hold", totals.hold);
      panel.setAttribute("data-total", totals.estimatedTotal);
    }, [eatalySimplified, cart]);
    const openSlotModal = function () {
      setSlotError(null);
      setStagedWindow(selectedWindow || null);
      setSlotModalOpen(true);
    };

    /** Cancel / X / Escape / backdrop all land here. Nothing was persisted, so
     *  the previously saved slot simply stays saved. */
    const closeSlotModal = function () {
      if (confirmingSlot) {
        return;
      }
      setSlotModalOpen(false);
      setStagedWindow(null);
      setSlotError(null);
    };
    const handleModalKeyDown = function (event) {
      if (event.key === "Escape" || event.key === "Esc") {
        event.stopPropagation();
        closeSlotModal();
        return;
      }
      if (event.key !== "Tab" || !dialogRef.current) {
        return;
      }
      const focusables = Array.prototype.filter.call(dialogRef.current.querySelectorAll(FOCUSABLE), function (element) {
        return !element.disabled && element.offsetParent !== null;
      });
      if (!focusables.length) {
        event.preventDefault();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || active === dialogRef.current)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    };

    /** Fresh availability for the active method + the cart's collections. */
    const fetchAvailability = function () {
      const method = normalizeMethod(activeMethod) || DELIVERY_METHOD;
      return get("shopify/private_shops/" + encodeURIComponent(shopify_domain) + "/available_windows?method=" + method + "&collections=" + collectionsQueryParam()).then(parseAvailableWindowsResult, function () {
        return {
          windows: [],
          error: true
        };
      });
    };

    /**
     * Write slot attributes and wait for Shopify to confirm them.
     *
     * CartJS.setAttributes is fire-and-forget and its queue is known to drop
     * callbacks while busy (see the shim in grocerbox.liquid), so there is no
     * reliable way to await it. /cart/update.js is the same endpoint CartJS
     * posts to, returns the updated cart, and lets us verify the attributes
     * actually landed rather than assuming a 200 means stored.
     */
    const writeSlotAttributes = function (serviceWindow) {
      const attributes = eatalyHelpers.slotAttributes(serviceWindow);
      return fetch(cartUpdateUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          attributes: attributes
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }
        return response.json();
      }).then(function (updatedCart) {
        const stored = updatedCart && updatedCart.attributes;
        const ok = serviceWindow ? eatalyHelpers.slotAttributesMatch(stored, serviceWindow) : eatalyHelpers.slotAttributesCleared(stored);
        if (!ok) {
          throw new Error("slot attributes were not stored");
        }
        setCart(Object.assign({}, updatedCart));
        if (serviceWindow) {
          writeGbLineItemProperty(updatedCart, serviceWindow.code, serviceWindow.name, normalizeMethod(activeMethod) || DELIVERY_METHOD);
        }
        return updatedCart;
      });
    };

    /**
     * Confirm re-fetches availability so cutoffs, capacity and collection
     * restrictions are re-applied server-side, persists only if the staged code
     * is still really there, and only closes once the write is confirmed.
     */
    const confirmSlot = function () {
      // Synchronous ref as well as state: two clicks in the same tick both see
      // the old `confirmingSlot` value, but only the first sees the ref false.
      if (!stagedWindow || confirmingSlotRef.current || !eatalyHelpers) {
        return;
      }
      const target = stagedWindow;
      confirmingSlotRef.current = true;
      setConfirmingSlot(true);
      setSlotError(null);
      fetchAvailability().then(function (result) {
        if (result.error) {
          setAvailabilityError(true);
          throw new Error("availability unavailable");
        }
        setAvailableWindows(result.windows);
        setAvailabilityError(false);
        const decision = eatalyHelpers.resolveSlotConfirmation(target, result.windows);
        if (decision.action !== "persist") {
          const message = decision.reason === "unavailable" ? "That time has just been taken. Please choose another." : "Please pick a date and a time first.";
          setStagedWindow(null);
          setSlotError(message);
          return null;
        }
        return writeSlotAttributes(decision.window).then(function () {
          // Only now is it safe to close.
          setSlotModalOpen(false);
          setStagedWindow(null);
          return decision.window;
        });
      }).catch(function (error) {
        const message = error && error.message === "availability unavailable" ? "We could not check that time. Check your connection and try again." : "We could not save that time. Please try again.";
        setSlotError(message);
      }).then(function () {
        confirmingSlotRef.current = false;
        setConfirmingSlot(false);
      });
    };
    const updateNotes = function (key, value) {
      const base = notesRef.current || readNotesFromCart(cart);
      const next = Object.assign({}, base);
      next[key] = value;
      notesRef.current = next;
      setNotes(next);
    };

    /**
     * Queue a notes save. Writes are serialised, and the payload is built when
     * the task actually runs, so a save queued behind another collapses to a
     * no-op once the earlier one has already stored that text. An older request
     * can therefore never land after — and overwrite — newer text.
     */
    const persistNotes = function () {
      if (!eatalyHelpers) {
        return Promise.resolve();
      }
      return notesQueueRef.current(function () {
        const payload = eatalyHelpers.buildNotesPayload(notesRef.current, savedNotesRef.current);
        if (!payload) {
          return Promise.resolve();
        }
        const pending = notesRef.current;
        return fetch(cartUpdateUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) {
            throw new Error("HTTP " + response.status);
          }
          return response.json();
        }).then(function () {
          savedNotesRef.current = pending;
          setSavedNotes(pending);
        });
      });
    };
    const handleNotesBlur = function () {
      persistNotes().then(function () {
        setNotesError(null);
      }, function () {
        setNotesError(NOTES_SAVE_ERROR);
      });
    };

    /**
     * Checkout gate. Reached by mouse click, by Enter inside the form, and by a
     * programmatic submit, so every guard lives here rather than relying on the
     * button's disabled state.
     *
     * 1. refuse while anything that disables checkout is true;
     * 2. flush any pending notes edit and wait for it;
     * 3. revalidate the saved slot against freshly fetched availability, since
     *    capacity or a cutoff may have moved since it was chosen;
     * 4. only then let the real submit through.
     */
    const handleCheckoutSubmit = function (event) {
      if (allowCheckoutSubmitRef.current) {
        allowCheckoutSubmitRef.current = false;
        return;
      }
      event.preventDefault();
      if (checkoutBusyRef.current) {
        return;
      }
      if (eatalyCheckoutBlocked) {
        setNotesError(null);
        setSlotError(null);
        setCheckoutError(checkoutBlockedReason);
        return;
      }
      checkoutBusyRef.current = true;
      setNotesSaving(true);
      setNotesError(null);
      setCheckoutError(null);
      persistNotes().then(function () {
        if (isShippingOrder) {
          return null;
        }
        const savedCode = cart && cart.attributes ? cart.attributes[WINDOW_CODE_KEY] : null;
        if (!savedCode) {
          throw new Error("slot-missing");
        }
        return fetchAvailability().then(function (result) {
          if (result.error) {
            setAvailabilityError(true);
            throw new Error("availability-unavailable");
          }
          setAvailableWindows(result.windows);
          setAvailabilityError(false);
          if (eatalyHelpers.validateSlot(savedCode, result.windows)) {
            return null;
          }
          // The slot went away between selection and checkout. Clear it so the
          // shopper cannot carry an invalid code into the order, then ask again.
          return writeSlotAttributes(null).then(function () {
            throw new Error("slot-invalidated");
          }, function () {
            throw new Error("slot-invalidated-dirty");
          });
        });
      }).then(function () {
        checkoutBusyRef.current = false;
        setNotesSaving(false);
        // Re-click the real submit button so Shopify still receives the
        // `checkout` parameter exactly as a plain user click would. React has
        // not flushed the setNotesSaving(false) render yet, so the DOM button is
        // still disabled and would swallow the click — clear it directly.
        const button = checkoutButtonRef.current;
        if (button) {
          allowCheckoutSubmitRef.current = true;
          button.disabled = false;
          button.click();
        } else {
          allowCheckoutSubmitRef.current = false;
        }
      }, function (error) {
        checkoutBusyRef.current = false;
        setNotesSaving(false);
        const reason = error && error.message;
        if (reason === "slot-missing") {
          setCheckoutError("Please choose a " + serviceLabel + " date and time before checking out.");
        } else if (reason === "slot-invalidated") {
          setCheckoutError("That " + serviceLabel + " time is no longer available. Please choose a new one.");
        } else if (reason === "slot-invalidated-dirty") {
          setCheckoutError("That " + serviceLabel + " time is no longer available and we could not clear it. Please reload the page and choose again.");
        } else if (reason === "availability-unavailable") {
          setCheckoutError("We could not confirm your " + serviceLabel + " time. Check your connection and try again.");
        } else {
          setNotesError(NOTES_SAVE_ERROR);
        }
      });
    };
    const slotDateLabel = function (serviceWindow) {
      if (!serviceWindow || !eatalyHelpers) {
        return null;
      }
      return eatalyHelpers.formatSlotDate(serviceWindow.date, {
        timeZone: storeTimezone || eatalyHelpers.DEFAULT_TIME_ZONE
      });
    };
    const renderDeliveryBlock = function () {
      const heading = isPickupOrder ? "Pickup date" : "Delivery date";
      // Until the first availability fetch resolves there is nothing truthful to
      // say — in particular, do not flash "no times available".
      if (!methodsReady || !loaded) {
        return React.createElement("div", {
          className: "eataly-slot"
        }, React.createElement("p", {
          className: "eataly-slot__label"
        }, heading), React.createElement("p", {
          className: "eataly-slot__value"
        }, "Checking availability…"));
      }
      if (showClosedMessage) {
        return React.createElement("div", {
          className: "eataly-slot"
        }, React.createElement("p", {
          className: "eataly-slot__label"
        }, heading), React.createElement("p", {
          className: "eataly-slot__value"
        }, "Store is currently closed"), React.createElement("p", {
          className: "eataly-slot__hint"
        }, closedMessage));
      }
      if (isShippingOrder) {
        return React.createElement("div", {
          className: "eataly-slot"
        }, React.createElement("p", {
          className: "eataly-slot__label"
        }, "Shipping"), React.createElement("p", {
          className: "eataly-slot__hint"
        }, config.t && config.t.rememberShippingCheckout || "Remember to select Shipping at checkout."));
      }
      const label = slotDateLabel(selectedWindow);
      const firstWindow = eatalyHelpers ? eatalyHelpers.firstAvailableWindow(availableWindows) : null;
      const isFirstAvailable = !!(selectedWindow && firstWindow && firstWindow.code === selectedWindow.code);
      const hasAvailability = availableWindows.length > 0;
      let guidance = "Choose a date and time to continue to checkout.";
      if (availabilityError) {
        guidance = "We could not load " + serviceLabel + " times. Check your connection and try again.";
      } else if (!hasAvailability) {
        guidance = "No " + serviceLabel + " times are available right now. Please check back later.";
      } else if (autoSelectError) {
        guidance = "We could not reserve the first available time. Please choose one below.";
      }
      return React.createElement("div", {
        className: "eataly-slot"
      }, React.createElement("p", {
        className: "eataly-slot__label"
      }, heading), selectedWindow && label ? React.createElement(React.Fragment, null, React.createElement("p", {
        className: "eataly-slot__value"
      }, label.label), React.createElement("p", {
        className: "eataly-slot__time"
      }, selectedWindow.name), isFirstAvailable ? React.createElement("p", {
        className: "eataly-slot__hint"
      }, "First available " + serviceLabel + " slot.") : null) : React.createElement(React.Fragment, null, React.createElement("p", {
        className: "eataly-slot__value"
      }, "Not selected yet"), React.createElement("p", {
        className: "eataly-slot__hint eataly-slot__hint--alert"
      }, guidance)), availabilityError ? React.createElement("button", {
        type: "button",
        className: "eataly-slot__change",
        onClick: function () {
          getAvailableWindows(cart, activeMethod);
        },
        disabled: loading || cartLoading
      }, "Try again") : React.createElement("button", {
        type: "button",
        className: "eataly-slot__change",
        ref: changeButtonRef,
        onClick: openSlotModal,
        disabled: !hasAvailability || loading || cartLoading
      }, (selectedWindow ? "Change " : "Choose ") + serviceLabel + " date or time"));
    };
    // Notepad glyph for the notes summary row. Inline so it matches the gift
    // rows' {% render 'icon' %} output without pulling in an icon library;
    // aria-hidden because the adjacent text already names the section.
    const renderNotepadIcon = function () {
      return React.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        focusable: "false"
      }, React.createElement("rect", {
        x: "5",
        y: "3",
        width: "14",
        height: "18",
        rx: "2"
      }), React.createElement("path", {
        d: "M9 3v3M15 3v3M9 11h6M9 15h4"
      }));
    };
    const renderNotesBlock = function () {
      const current = notes || readNotesFromCart(cart);
      const substitution = current.substitutions || DEFAULT_SUBSTITUTION;
      let substitutionHelp = "Our team will substitute any out of stock products with the most similar alternative.";
      if (substitution === "Allow Substitutions (Call)") {
        substitutionHelp = "Our team will call you if a product is unavailable and suggest a substitution. If the call isn’t answered we will refund you for the missing product.";
      } else if (substitution === "No Substitutions") {
        substitutionHelp = "We will refund any unavailable products.";
      }
      return React.createElement("form", {
        method: "post",
        action: config.shopifyCartUrl || "/cart",
        noValidate: "novalidate",
        onSubmit: handleCheckoutSubmit
      }, React.createElement("input", {
        type: "hidden",
        name: "attributes[collection_products_per_page]",
        value: ""
      }), React.createElement("input", {
        type: "hidden",
        name: "attributes[collection_layout]",
        value: ""
      }), React.createElement("details", {
        className: "eataly-notes"
      }, React.createElement("summary", {
        className: "eataly-notes__summary"
      }, React.createElement("span", {
        className: "eataly-gift__icon"
      }, renderNotepadIcon()), React.createElement("span", {
        className: "eataly-gift__label"
      }, React.createElement("span", {
        className: "eataly-notes__title"
      }, "Order notes & substitutions"), React.createElement("span", {
        className: "eataly-notes__preview"
      }, "Substitutions: " + substitution)), React.createElement("span", {
        className: "eataly-gift__toggle"
      })), React.createElement("div", {
        className: "eataly-notes__body"
      }, React.createElement("div", {
        className: "eataly-notes__field"
      }, React.createElement("label", {
        htmlFor: "eataly-order-instructions"
      }, "Order instructions (optional)"), React.createElement("textarea", {
        id: "eataly-order-instructions",
        name: "note",
        rows: "3",
        placeholder: "Let us know here if you have any special requests.",
        value: current.note,
        onChange: function (event) {
          updateNotes("note", event.target.value);
        },
        onBlur: handleNotesBlur
      })), config.hideDeliveryInstructions ? null : React.createElement("div", {
        className: "eataly-notes__field"
      }, React.createElement("label", {
        htmlFor: "eataly-delivery-instructions"
      }, "Delivery instructions (optional)"), React.createElement("textarea", {
        id: "eataly-delivery-instructions",
        name: "attributes[" + DELIVERY_NOTE + "]",
        rows: "3",
        placeholder: "Indicate any delivery instructions, buzzer numbers, etc.",
        value: current.deliveryNote,
        onChange: function (event) {
          updateNotes("deliveryNote", event.target.value);
        },
        onBlur: handleNotesBlur
      })), config.showSubstitutions ? React.createElement("div", {
        className: "eataly-notes__field"
      }, React.createElement("label", {
        htmlFor: "eataly-substitutions"
      }, "Substitutions"), React.createElement("select", {
        id: "eataly-substitutions",
        name: "attributes[" + SUBSTITUTIONS + "]",
        value: substitution,
        onChange: function (event) {
          updateNotes("substitutions", event.target.value);
          // Selects have no meaningful blur-after-change, so save immediately.
          setTimeout(handleNotesBlur, 0);
        }
      }, React.createElement("option", {
        value: "Allow Substitutions (Don't Call)"
      }, "Allow Substitutions (Don't Call)"), React.createElement("option", {
        value: "Allow Substitutions (Call)"
      }, "Allow Substitutions (Call)"), React.createElement("option", {
        value: "No Substitutions"
      }, "No Substitutions")), React.createElement("p", {
        className: "eataly-notes__help"
      }, substitutionHelp)) : null)), React.createElement("div", {
        className: "eataly-card__section"
      }, notesError ? React.createElement("p", {
        className: "eataly-alert",
        role: "alert"
      }, notesError) : null, checkoutError ? React.createElement("p", {
        className: "eataly-alert",
        role: "alert"
      }, checkoutError) : null,
      /* The section renders the alcohol/food notice itself, so this one would be a duplicate. */
      cannotBeSoldAlone && !foodPolicy.enabled ? React.createElement("p", {
        className: "eataly-alert eataly-alert--notice"
      }, "Products from " + collectionsToCompare.join(", ") + " cannot be purchased alone. Please add a food item to your cart.") : null, cartMinimumCents > 0 && cartBelowMinimum && !cannotBeSoldAlone ? React.createElement("p", {
        className: "eataly-alert eataly-alert--notice"
      }, "Minimum order of " + formatCurrency(cartMinimumCents) + " required. Please add " + formatCurrency(cartMinimumShortfall) + " more to continue to checkout.") : null, React.createElement("button", {
        type: "submit",
        name: "checkout",
        ref: checkoutButtonRef,
        className: "eataly-checkout",
        disabled: eatalyCheckoutBlocked || notesSaving
      }, notesSaving ? "Checking…" : checkoutButtonLabel)));
    };
    const renderSlotModal = function () {
      const stagedLabel = slotDateLabel(stagedWindow);
      return React.createElement("div", {
        className: "eataly-modal",
        onMouseDown: function (event) {
          if (event.target === event.currentTarget) {
            closeSlotModal();
          }
        }
      }, React.createElement("div", {
        className: "eataly-modal__dialog",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "eataly-slot-dialog-title",
        tabIndex: -1,
        ref: dialogRef,
        onKeyDown: handleModalKeyDown,
        style: {
          "--gb-btn-color": config.btnColor,
          "--gb-text-color": config.textColor || "white"
        }
      }, React.createElement("div", {
        className: "eataly-modal__header"
      }, React.createElement("h2", {
        className: "eataly-modal__title",
        id: "eataly-slot-dialog-title"
      }, "Change " + serviceLabel + " date or time"), React.createElement("button", {
        type: "button",
        className: "eataly-modal__close",
        "aria-label": "Close",
        onClick: closeSlotModal,
        disabled: confirmingSlot
      }, "✕")), React.createElement("div", {
        className: "eataly-modal__body"
      }, React.createElement(ServiceWindow, {
        active: !!stagedWindow,
        loading: false,
        handleClick: function (serviceWindow) {
          // Staged only — nothing is written to the cart until Confirm.
          setStagedWindow(serviceWindow);
          setSlotError(null);
        },
        window: stagedWindow,
        availableWindows: availableWindows,
        activeMethod: activeMethod,
        btnColor: config.btnColor
      })), React.createElement("div", {
        className: "eataly-modal__footer"
      }, slotError ? React.createElement("p", {
        className: "eataly-alert",
        role: "alert"
      }, slotError) : null, React.createElement("p", {
        className: "eataly-modal__selection"
      }, stagedWindow && stagedLabel ? "Selected: " + stagedLabel.label + " · " + stagedWindow.name : "Pick a date, then a time."), React.createElement("button", {
        type: "button",
        className: "eataly-modal__confirm",
        onClick: confirmSlot,
        disabled: !stagedWindow || confirmingSlot
      }, confirmingSlot ? "Confirming…" : "Confirm " + serviceLabel + " slot"), React.createElement("button", {
        type: "button",
        className: "eataly-modal__cancel",
        onClick: closeSlotModal,
        disabled: confirmingSlot
      }, "Cancel"))));
    };
    const checkoutButtonLabel = function () {
      if (!checkoutDisabled) return "Checkout";
      if (cannotBeSoldAlone) return foodPolicy.enabled ? "Add a food item" : "Add Items To Cart";
      if (cartBelowMinimum) return "Add More Items";
      if (isShippingOrder) {
        if (loading || cartLoading) return "Loading…";
        return "Checkout";
      }
      return "Select a time slot";
    }();
    const showMethodSelector = methodsReady && allowSelectingMethod;
    const methodSelector = showMethodSelector ? React.createElement(ButtonGroup, {
      style: {
        marginBottom: "1rem"
      }
    }, methodAvailability.pickup ? React.createElement(MethodButton, {
      type: "button",
      active: isPickupOrder,
      onClick: function (e) {
        e.preventDefault();
        setMethod(PICKUP_METHOD);
      },
      disabled: !cart || cartLoading
    }, config.t && config.t.labelPickup || "Pickup") : null, methodAvailability.delivery ? React.createElement(MethodButton, {
      type: "button",
      active: isLocalDelivery,
      onClick: function (e) {
        e.preventDefault();
        setMethod(DELIVERY_METHOD);
      },
      disabled: !cart || cartLoading
    }, config.t && config.t.labelLocalDelivery || "Local Delivery") : null, showShippingMethod ? React.createElement(MethodButton, {
      type: "button",
      active: isShippingOrder,
      onClick: function (e) {
        e.preventDefault();
        setMethod(SHIPPING_METHOD);
      },
      disabled: !cart || cartLoading
    }, config.t && config.t.labelShipping || "Shipping") : null) : null;
    const noLocalMethods = methodsReady && !methodAvailability.pickup && !methodAvailability.delivery;
    const showClosedMessage = noLocalMethods && (!allowSelectingMethod || allowSelectingMethod && !showShippingMethod);
    const closedMessage = config.t && config.t.closedMessage || "We’re not accepting pickup or local delivery orders right now. Please check back later.";
    const helperNotice = showMethodSelector ? isPickupOrder ? "Remember to select Pickup at checkout." : isLocalDelivery ? "Remember to select Delivery at checkout." : isShippingOrder ? config.t && config.t.rememberShippingCheckout || "Remember to select Shipping at checkout." : "Select Pickup or Delivery to view available time slots." : config.t && config.t.pickupDeliveryNotice || "Pickup or Delivery can be selected at checkout.";
    if (eatalySimplified) {
      // The delivery summary renders into #gb-component; the notes accordion
      // and checkout portal into #gb-cart-notes so the Liquid gift rows can sit
      // between them. One component instance, one cart state, no duplicate
      // availability fetching.
      const notesBlock = renderNotesBlock();
      return React.createElement("div", {
        className: "eataly-slot-root",
        style: {
          "--gb-btn-color": config.btnColor,
          "--gb-text-color": config.textColor || "white"
        }
      }, renderDeliveryBlock(), notesMount ? ReactDOM.createPortal(notesBlock, notesMount) : notesBlock, slotModalOpen && typeof document !== "undefined" ? ReactDOM.createPortal(renderSlotModal(), document.body) : null);
    }
    if (!methodsReady) {
      return React.createElement(Container, {
        style: {
          "--gb-btn-color": config.btnColor,
          "--gb-text-color": config.textColor || "white"
        }
      }, React.createElement(CalendarCard, null, React.createElement(CalendarHeader, null, React.createElement("h2", {
        style: {
          fontSize: "1.3rem",
          fontWeight: "700",
          color: "#1f2937"
        }
      }, "Checking availability…"))));
    }
    if (showClosedMessage) {
      return React.createElement(Container, {
        style: {
          "--gb-btn-color": config.btnColor,
          "--gb-text-color": config.textColor || "white"
        }
      }, React.createElement(CalendarCard, null, React.createElement(CalendarHeader, null, React.createElement("h2", {
        style: {
          fontSize: "1.3rem",
          fontWeight: "700",
          color: "#1f2937"
        }
      }, "Store is currently closed")), React.createElement("div", {
        style: {
          padding: "1.5rem",
          backgroundColor: "#f9fafb"
        }
      }, React.createElement("p", {
        style: {
          color: "#374151",
          fontSize: "1.05rem"
        }
      }, closedMessage))));
    }
    return React.createElement(Container, {
      style: {
        "--gb-btn-color": config.btnColor,
        "--gb-text-color": config.textColor || "white"
      }
    }, methodSelector, React.createElement("div", null, React.createElement("p", {
      style: {
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
        textAlign: "center",
        fontSize: "1.25rem"
      }
    }, React.createElement("small", null, helperNotice))),
    /**
     * Discoverability hint: the checkout button already says "Select a time
     * slot" while disabled, but customers scrolling a long cart page can
     * miss that there's a calendar right below asking for input and assume
     * the button/page is broken. Point at it explicitly while a slot is
     * still required (Kalustyans "checkout button greyed out" report).
     */
    !isShippingOrder && timeslotRequired && !loading && !cartLoading && !cannotBeSoldAlone && !cartBelowMinimum ? React.createElement("div", {
      style: {
        marginBottom: "0.75rem",
        border: "1px solid #f59e0b",
        backgroundColor: "#fffbeb",
        color: "#92400e",
        borderRadius: "0.5rem",
        padding: "0.6rem 1rem",
        textAlign: "center",
        fontWeight: 600
      }
    }, isPickupOrder ? config.t && config.t.selectSlotHintPickup || "↓ Select a pickup date and time below to continue to checkout" : config.t && config.t.selectSlotHintDelivery || "↓ Select a delivery date and time below to continue to checkout") : null, methodsReady && !showClosedMessage && !isShippingOrder ? React.createElement(ServiceWindow, {
      active: selectedWindow !== null,
      loading: loading || cartLoading,
      handleClick: function (window) {
        selectWindow(window);
      },
      window: selectedWindow,
      availableWindows: availableWindows,
      activeMethod: activeMethod
    }) : null, React.createElement("div", {
      style: {
        maxWidth: "28rem",
        margin: "0 auto",
        paddingTop: "1.6rem"
      }
    }, React.createElement("form", {
      method: "post",
      action: config.shopifyCartUrl || "/cart",
      noValidate: "novalidate"
    }, React.createElement("input", {
      type: "hidden",
      name: "attributes[collection_products_per_page]",
      value: ""
    }), React.createElement("input", {
      type: "hidden",
      name: "attributes[collection_layout]",
      value: ""
    }), React.createElement("div", {
      className: "gb-timeslots-form"
    }, React.createElement(GbFormSectionLabel, null, "Order Instructions"), React.createElement(GbFieldWrapper, null, React.createElement(TextArea, {
      className: "gb-timeslots-textarea",
      placeholder: "Let us know here if you have any special requests.",
      onBlur: function (event) {
        CartJS.setNote(event.target.value);
      },
      rows: "3",
      defaultValue: cart ? cart.note : ""
    })), !config.hideDeliveryInstructions ? React.createElement(React.Fragment, null, React.createElement(GbFormSectionLabel, null, "Delivery Notes"), React.createElement(GbFieldWrapper, null, React.createElement(TextArea, {
      className: "gb-timeslots-textarea",
      placeholder: "Indicate any delivery instructions, buzzer numbers, etc.",
      onBlur: function (event) {
        CartJS.setAttribute(DELIVERY_NOTE, event.target.value);
      },
      rows: "3",
      defaultValue: cart && cart.attributes ? cart.attributes[DELIVERY_NOTE] : ""
    }))) : null, config.showSubstitutions ? React.createElement(React.Fragment, null, React.createElement(GbFormSectionLabel, null, "Substitutions"), React.createElement(GbFieldWrapper, null, React.createElement(GbSelect, {
      className: "gb-timeslots-select",
      name: "attributes[Substitutions]",
      onChange: function (event) {
        CartJS.setAttribute(SUBSTITUTIONS, event.target.value);
      },
      defaultValue: cart && cart.attributes ? cart.attributes[SUBSTITUTIONS] : "Allow Substitutions"
    }, React.createElement("option", {
      value: "Allow Substitutions (Don't Call)"
    }, "Allow Substitutions (Don't Call)"), React.createElement("option", {
      value: "Allow Substitutions (Call)"
    }, "Allow Substitutions (Call)"), React.createElement("option", {
      value: "No Substitutions"
    }, "No Substitutions"))), React.createElement("p", {
      style: {
        marginTop: "0.35rem",
        color: "inherit",
        opacity: 0.82
      }
    }, React.createElement("small", null, cart && cart.attributes && (!cart.attributes[SUBSTITUTIONS] || cart.attributes[SUBSTITUTIONS] === "Allow Substitutions (Don't Call)") ? "Our team will substitute any out of stock products with the most similar alternative." : "", cart && cart.attributes && cart.attributes[SUBSTITUTIONS] === "Allow Substitutions (Call)" ? "Our team will call you if a product is unavailable and suggest a substitution. If the call isn’t answered we will refund you for the missing product." : "", cart && cart.attributes && cart.attributes[SUBSTITUTIONS] === "No Substitutions" ? "We will refund any unavailable products." : ""))
    // React.createElement("br", null)
    ) : null, config.showMembershipInput ? React.createElement(MembershipInput, {
      label: config.membershipInputLabel || "Membership Number",
      placeholder: config.membershipInputPlaceholder || "Enter your member number",
      value: membershipNumber,
      onChange: function (e) {
        setMembershipNumber(e.target.value);
      },
      onBlur: handleMembershipBlur,
      helpText: config.nonMemberFeeHelpText
    }) : null, config.showMemberEmailInput ? React.createElement(MembershipInput, {
      label: config.memberEmailInputLabel || "Member Email",
      placeholder: config.memberEmailInputPlaceholder || "Enter your member email",
      value: memberEmail,
      onChange: function (e) {
        setMemberEmail(e.target.value);
      },
      onBlur: handleMemberEmailBlur,
      helpText: config.memberEmailHelpText
    }) : null), React.createElement(CheckoutButton, {
      type: "submit",
      name: "checkout",
      disabled: checkoutDisabled,
      className: "gb-timeslots-checkout",
      btnColor: config.btnColor
    }, checkoutButtonLabel), cartMinimumCents > 0 && cartBelowMinimum && !cannotBeSoldAlone ? React.createElement("div", {
      style: {
        marginTop: "0.75rem",
        border: "1px solid #f59e0b",
        backgroundColor: "#fffbeb",
        color: "#92400e",
        borderRadius: "0.5rem",
        padding: "0.75rem 1rem",
        display: "flex",
        alignItems: "center",
        gap: "0.75rem"
      }
    }, React.createElement("span", {
      "aria-hidden": "true",
      style: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "2rem",
        height: "2rem",
        borderRadius: "9999px",
        backgroundColor: "#fbbf24",
        color: "#78350f",
        fontWeight: 700,
        fontSize: "1.1rem"
      }
    }, "!"), React.createElement("div", {
      style: {
        lineHeight: 1.4
      }
    }, React.createElement("strong", {
      style: {
        display: "block"
      }
    }, "Minimum order of " + formatCurrency(cartMinimumCents) + " required"), React.createElement("span", null, "Please add " + formatCurrency(cartMinimumShortfall) + " more to continue to checkout."))) : null,
    /* The section renders the alcohol/food notice itself, so this one would be a duplicate. */
    cannotBeSoldAlone && !foodPolicy.enabled ? React.createElement("p", null, React.createElement("b", null, "Products from " + collectionsToCompare.join(", ") + " cannot be purchased alone. Please add a food item to your cart")) : null)));
  }
  if (typeof console !== "undefined" && typeof console.info === "function") {
    var gbAssignDiag = {
      hasGbComponent: !!document.getElementById("gb-component"),
      hasGbCartNotes: !!document.getElementById("gb-cart-notes"),
      readyState: document.readyState,
      dependencies: {
        hasReact: typeof window.React !== "undefined",
        hasReactDOM: typeof window.ReactDOM !== "undefined",
        hasStyledGlobal: typeof window.styled !== "undefined",
        styledDivOnGlobal: typeof window.styled === "function" && typeof window.styled.div === "function",
        usingResolvedStyled: !!window.__GROCERBOX_STYLED_COMPONENTS__
      }
    };
    console.info("[GrocerBox][TimeSlot]", "Assigning GrocerBoxTimeSlotInit", gbAssignDiag);
  }
  window.GrocerBoxTimeSlotInit = function (config) {
    // #gb-component is emitted well before #gb-cart-notes in the cart section,
    // so a parse-time render can see the first and miss the second. notesMount
    // is seeded once per mount via useState, so rendering that early latches it
    // to null for the life of the root and the notes panel plus Checkout render
    // inline above the Liquid gift rows instead of into their portal. Hold the
    // first render until both targets exist.
    var polling = false;
    function eatalySimplifiedNow() {
      // Read the flag late: grocerbox.liquid re-asserts it after GrocerBox.init.
      return !!config && config.eatalyCartSimplification === true || !!window.gbTimeSlotsConfig && window.gbTimeSlotsConfig.eatalyCartSimplification === true;
    }
    function notesTargetReady() {
      return !eatalySimplifiedNow() || !!document.getElementById("gb-cart-notes");
    }
    function renderWidget(mount) {
      ReactDOM.render(React.createElement(GrocerBoxComponent, {
        config: config
      }), mount);
    }
    function tryRender(label) {
      var mount = document.getElementById("gb-component");
      if (!mount || !notesTargetReady()) {
        return false;
      }
      try {
        renderWidget(mount);
        return true;
      } catch (err) {
        console.error("[GrocerBox][TimeSlot]", "Render failed" + (label ? " (" + label + ")" : ""), err);
        setTimeout(function () {
          var m = document.getElementById("gb-component");
          if (m && notesTargetReady()) {
            renderWidget(m);
          } else {
            startPoll(label ? label + ":retry" : "retry");
          }
        }, 1000);
        return true;
      }
    }
    function startPoll(label) {
      if (polling) {
        return;
      }
      polling = true;
      var deadline = Date.now() + 15000;
      var poll = setInterval(function () {
        if (tryRender(label) || Date.now() > deadline) {
          clearInterval(poll);
          polling = false;
          if (!document.getElementById("gb-component")) {
            console.error("[GrocerBox][TimeSlot]", 'No element id="gb-component". Add <div id="gb-component"></div> where the time slot widget should appear (see grocerbox.liquid).');
          } else if (!notesTargetReady()) {
            console.error("[GrocerBox][TimeSlot]", 'No element id="gb-cart-notes" on the simplified cart, so the notes panel and Checkout never mounted. Add <div id="gb-cart-notes"></div> to the cart template (see cart-template.liquid).');
          }
        }
      }, 50);
    }
    if (!tryRender("initial")) {
      startPoll("poll");
    }
    $(document).on("theme:loading:end", function (event) {
      setTimeout(function () {
        if (!tryRender("theme:loading:end")) {
          startPoll("theme:loading:end:poll");
        }
      }, 500);
    });

    // The theme's AJAX cart reload swaps the whole section's innerHTML, which
    // detaches both this mount and the #gb-cart-notes portal target. Re-render
    // as soon as that lands instead of waiting out the 500ms timer above, so
    // the checkout button isn't missing in between.
    $(document).on("cart:rerendered", function () {
      if (!tryRender("cart:rerendered")) {
        startPoll("cart:rerendered:poll");
      }
    });
  };
})();
